import { axiosV2 } from 'interceptors/axios';
import { store } from 'redux/store';
import { decryptResponse } from 'utils/token';

type GetPartnerCustomMovements = {
  partnerId: string;
  societyId: string;
};

export const getPartnerCustomMovements = async ({
  partnerId,
  societyId,
}: GetPartnerCustomMovements) => {
  const query = { params: { partnerId, societyId } };

  try {
    const { data } = await axiosV2.get('/partners/customMovements', query);

    const decodedData = await decryptResponse(data);

    return decodedData;
  } catch (error) {
    store.dispatchError(error, store.dispatch);
  }
};
